import isNotNil from '../../../ldsh/isNotNil'
import getUnitMoveCostOntoPositionEntityStack from '../../entity/getUnitMoveCostOntoPositionEntityStack'
import type { Entity } from '../../entity/index'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'

export default function createMovementCostGridUInt8Array(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to move
  unit: Entity
): Uint8Array {
  const data = new Uint8Array(gridWidth * gridHeight)
  data.fill(255)

  for (let x = 0; x < gridWidth; x++) {
    for (let y = 0; y < gridHeight; y++) {
      const index = x + (y * gridWidth)
      const positionStack = grid[index]
      if (positionStack) {
        const value = getUnitMoveCostOntoPositionEntityStack(unit, positionStack)
        if (isNotNil(value)) {
          data[index] = value
        }
      }
    }
  }
  return data
}
